import React from 'react'
import { components, createFilter } from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import { searchRecipes } from '@/api'
import { Flex } from '@/components/Flex'
import { withAsyncPaginate } from 'react-select-async-paginate'
import { Select } from '@/components/Select'
import { Recipe } from '@/api/types'

export type Ing = {
  idIngredient: number
  name: string
  englishName: string
}

type Props = {
  onChange: (value: Recipe[]) => void
}

const SelectPaginate = withAsyncPaginate(Select as any)

export default function RecipesSearch({ onChange }: Props) {
  const [currentSelection, setCurrentSelection] = React.useState<Recipe[]>([])

  async function loadOptions(search, _loadedOptions: Recipe[], { page }) {
    let data = (
      await searchRecipes({ page: page - 1, pageSize: 101, searchText: search, model: 'SIMPLE' })
    ).data

    return {
      options: data?.slice(0, 99),
      hasMore: data?.length > 100,
      additional: {
        page: page + 1,
      },
    }
  }

  function handleChange(value: Recipe[]) {
    setCurrentSelection(value)
    onChange(value)
  }

  return (
    <SelectPaginate
      isMulti
      loadOptions={loadOptions}
      debounceTimeout={300}
      filterOption={createFilter({ ignoreAccents: false })}
      additional={{
        page: 1,
      }}
      value={currentSelection}
      formatOptionLabel={(item) => (
        <Flex direction="column" gap={2}>
          <div>{item?.name}</div>
        </Flex>
      )}
      getOptionLabel={(item) => (item ? item.name : '')}
      getOptionValue={(item) => (item ? item.idRecipe.toString() : '')}
      onChange={handleChange}
      components={{
        Placeholder,
        IndicatorSeparator: null,
      }}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          marginTop: 8,
          padding: 4,
          borderColor: 'var(--border-color)',
          backgroundColor: 'var(--field-background)',
        }),
        placeholder: (baseStyles) => ({
          ...baseStyles,
        }),
      }}
    />
  )
}

function Placeholder(props) {
  return (
    <components.Placeholder {...props}>
      <FontAwesomeIcon icon={faSearch} />
    </components.Placeholder>
  )
}
